export default __webpack_public_path__ + "static/exp6-5f2fe8d7e190aab4e469b7b623ec4f81.png";